var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "query-form",
          attrs: { size: "small", inline: true, model: _vm.searchForm },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.refreshList()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "name" } },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "名称", clearable: "" },
                model: {
                  value: _vm.searchForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "name", $$v)
                  },
                  expression: "searchForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh-right" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white top" },
        [
          _c("vxe-toolbar", {
            attrs: {
              refresh: { query: _vm.refreshList },
              export: "",
              print: "",
              custom: "",
            },
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    _c(
                      "el-row",
                      [
                        _vm.hasPermission("datav:dataScreenCategory:add")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  icon: "el-icon-plus",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.add()
                                  },
                                },
                              },
                              [_vm._v("新建")]
                            )
                          : _vm._e(),
                        _vm.hasPermission("datav:dataScreenCategory:edit")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "warning",
                                  size: "small",
                                  icon: "el-icon-edit-outline",
                                  disabled:
                                    _vm.$refs.dataScreenCategory &&
                                    _vm.$refs.dataScreenCategory.getCheckboxRecords()
                                      .length !== 1,
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit()
                                  },
                                },
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e(),
                        _vm.hasPermission("datav:dataScreenCategory:del")
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "small",
                                  icon: "el-icon-delete",
                                  disabled:
                                    _vm.$refs.dataScreenCategory &&
                                    _vm.$refs.dataScreenCategory.getCheckboxRecords()
                                      .length === 0,
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.del()
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 50px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "dataScreenCategory",
                  attrs: {
                    border: "inner",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    "row-id": "id",
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "print-config": {},
                    "export-config": {},
                    "tree-config": {},
                    loading: _vm.loading,
                    "checkbox-config": { checkStrictly: true },
                    data: _vm.dataList,
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "40px" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "name",
                      align: "left",
                      "tree-node": "",
                      title: "名称",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission("datav:dataScreenCategory:edit")
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.name))]
                                )
                              : _vm.hasPermission(
                                  "datav:dataScreenCategory:view"
                                )
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.name))]
                                )
                              : _c("span", [_vm._v(_vm._s(scope.row.name))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { field: "remarks", title: "备注信息" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      width: "300px",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission("datav:dataScreenCategory:view")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      icon: "el-icon-view",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                )
                              : _vm._e(),
                            _vm.hasPermission("datav:dataScreenCategory:edit")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      icon: "el-icon-edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                )
                              : _vm._e(),
                            _vm.hasPermission("datav:dataScreenCategory:del")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            _vm.hasPermission("datav:dataScreenCategory:add")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      icon: "el-icon-circle-plus-outline",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addChild(
                                          scope.row.id,
                                          scope.row.name
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("添加下级大屏分类")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("DataScreenCategoryForm", {
        ref: "dataScreenCategoryForm",
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }